import React from 'react';
import BaseAutoComplete from '../base-auto-complete';
import { AddFunnelPropFromContext } from '../funnel-context';
import { visaList } from './visasList';
import { visaSuggestionsList } from './suggestionsList';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
const LABELS = {
  ARHI: DEFAULT_LABELS.VISA_SUBCLASS
};
const VisaSubclass = props => {
  const {
    funnel = FUNNELS.ARHI,
    help,
    width = 30,
    label,
    options = visaList,
    suggestions = visaSuggestionsList,
    input,
    field,
    ...otherProps
  } = props;
  return React.createElement(BaseAutoComplete, {
    label: label || LABELS[funnel] || LABELS.ARHI,
    help: help,
    width: width,
    options: options,
    suggestionList: suggestions,
    keys: ['value', 'text', 'aliases'],
    field: field,
    input: input,
    funnel: funnel,
    ...otherProps
  });
};
VisaSubclass.defaultProps = {
  options: visaList,
  suggestions: visaSuggestionsList,
  width: 30
};
const VisaSubclassWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(VisaSubclass, {
  ...props
}));
export default VisaSubclassWithFunnel;